import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class CompanyQueryCriteriaClass extends BaseCriteriaModel {
  // Header table
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  tax_registration_id?: Optional<string> = Optional.empty();
  comp_registration_num?: Optional<number> = Optional.empty();
  comp_hdr_guid?: Optional<string> = Optional.empty();
  created_date_from?: Optional<string> = Optional.empty();
  created_date_to?: Optional<string> = Optional.empty();
  ccy_code?: Optional<string> = Optional.empty();

  // Ext table
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
}

export class CompanyCriteriaModelQuery {
  query = '';

  constructor(companyCriteriaModel: CompanyQueryCriteriaClass) {

    if (!companyCriteriaModel) {
      return;
    }

    this.query += companyCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += companyCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += companyCriteriaModel.tax_registration_id.filter(x => x !== '').map(x => '&tax_registration_id=' + x).orElse('');
    this.query += companyCriteriaModel.comp_registration_num.filter(x => x !== null).map(x => '&comp_registration_num=' + x).orElse('');
    this.query += companyCriteriaModel.comp_hdr_guid.filter(x => x !== '').map(x => '&comp_hdr_guid=' + x).orElse('');
    this.query += companyCriteriaModel.created_date_from.filter(x => x !== '').map(x => '&created_date_from=' + x).orElse('');
    this.query += companyCriteriaModel.created_date_to.filter(x => x !== '').map(x => '&created_date_to=' + x).orElse('');
    this.query += companyCriteriaModel.ccy_code.filter(x => x !== '').map(x => '&ccy_code=' + x).orElse('');

    this.query += companyCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += companyCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += companyCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += companyCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += companyCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');


    this.query += '&status=' + companyCriteriaModel.status;
    // this.query += '&orderBy=' + companyCriteriaModel.orderBy;
    this.query += '&order=' + companyCriteriaModel.order;
    this.query += '&offset=' + companyCriteriaModel.offset + '&limit=' + companyCriteriaModel.limit;
  }
}
